export default __webpack_public_path__ + "static/media/Screenshot 2021-06-09 085604.87da5c4d.png";